import React, { useState, Fragment, useContext, useEffect } from "react";
import styled, { css } from "styled-components";
import PAgameKeysWizard from "./gk/PAgameKeysWizard";

import {
  InputCopy,
  FormGroup,
  Select,
  Tooltip,
  StatusDot,
  Checkbox,
  Subheader,
  Button,
  Breadcrumbs,
  Head,
  Card,
  Input,
  Pill,
  RadioGroup,
  Icon,
  Tag,
  FormFooter,
  Notification
} from "xsolla-uikit";

import PAtabs from "./PAtabs";

import { PAinfoCollapsible } from './uikit2';




import merge from "deepmerge";
import { ContextConsumer } from "./../App";
import { IntlProvider } from "react-intl";
import PAContentBlock from "./PAContentBlock";
import { Link } from "react-router-dom";

import { GameKeyWizard_temp } from "./gk/PAgcGameKeyWizard";

import PAgkRefund from "./ffr/PAgkRefund";

import CardNew, {
  CardItem,
  CardTodo,
  CardSite,
  CardFlatten
} from "./PAcardNew";

import { PAchart1, PAchartMap } from "./PAcharts";
import { PAchart1fake, PAchart2 } from "./PAchart2";

import { game_keys } from '../data/game_keys';

export default function PAgkDashboard({
  history,
  view = 'row',
 }) {

  const [cardType, setCardType] = useState(view);




  // useEffect(() => {
  //   if (history.match.location === )
  // }, [history])

  const [newKey, setNewKey] = useState(false);


  const [tab, setTab] = useState("cat");

  return (
    <Fragment>

      <FormGroup indentation="lg">
        <CSScards
          cardType={cardType}
        >


            {game_keys.map((oneKey, ind) => {
              return (
                // <FormGroup indentation="lg" key={`login_${ind}`}>
                <CssCardItem
                  size="sm"
                  cardType={cardType}
                >
                  <CardItem
                    product="game_store"
                    appearance="flatten"
                    cardType={cardType}
                    size="sm"
                    {...oneKey}
                    key={`login_${ind}`}
                    />
                </CssCardItem>
                // </FormGroup>
              );
            })}

        </CSScards>
      </FormGroup>

      <FormGroup indentation="lg">
        <div style={{display: 'flex'}}>
          <Button
            style={{opacity: cardType === 'row' ? 0.4 : 1}}
            onClick={()=>{setCardType(false)}}
            appearance="flatten">Cards</Button>&nbsp;
          <Button
            style={{opacity: cardType !== 'row' ? 0.4 : 1}}
            onClick={()=>{setCardType('row')}}
            appearance="flatten">Rows</Button>
        </div>
      </FormGroup>

    </Fragment>
  );
}

const CSScards = styled.div`
  ${({ cardType }) =>
    cardType === 'row'
      ? css`
          width: 100%;
          display: grid;
          grid-template-columns: 1fr;
          grid-column-gap: 24px;
          grid-auto-rows: minmax(min-content, max-content);
          grid-row-gap: 24px;
          place-content: stretch;
        `
      : css`
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
          grid-column-gap: 24px;
          grid-row-gap: 24px;
          place-content: stretch;
        `};
`;

const CssCardItem = styled.div`
  display: flex;
  align-items: stretch;
  width: 100%;
  grid-row-gap: 44px;
  flex-grow: 1;
  ${({ cardType }) =>
    cardType === 'row'
      ? css`
          min-height: 200px
        `
      : css`

        `};
`;



